function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "511pt",
    viewBox: "1 -19 511.99999 511",
    width: "511pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 400.542969 0.5 L 89.59375 0.5 C 78.785156 0.5 70.023438 9.261719 70.023438 20.070312 L 70.023438 62.878906 L 420.113281 62.878906 L 420.113281 20.070312 C 420.113281 9.261719 411.351562 0.5 400.542969 0.5 Z M 400.542969 0.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,81.568627%,40%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 400.542969 0.5 L 366.46875 0.5 L 366.46875 62.878906 L 420.113281 62.878906 L 420.113281 20.070312 C 420.113281 9.261719 411.351562 0.5 400.542969 0.5 Z M 400.542969 0.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078431%,70.980392%,33.72549%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28.65625 68.488281 L 28.65625 422.804688 C 28.65625 435.007812 38.546875 444.898438 50.75 444.898438 L 439.371094 444.898438 C 451.574219 444.898438 461.46875 435.007812 461.46875 422.804688 L 461.46875 68.488281 Z M 28.65625 68.488281 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,94.901961%,94.901961%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 407.820312 68.488281 L 407.820312 444.898438 L 439.371094 444.898438 C 451.574219 444.898438 461.46875 435.007812 461.46875 422.804688 L 461.46875 68.488281 Z M 407.820312 68.488281 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(85.882353%,85.098039%,81.960784%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 455.113281 169.597656 C 435.777344 169.597656 420.105469 153.925781 420.105469 134.589844 L 420.105469 117.40625 L 490.121094 117.40625 L 490.121094 134.589844 C 490.121094 153.925781 474.449219 169.597656 455.113281 169.597656 Z M 455.113281 169.597656 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,24.313725%,22.745098%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 385.097656 169.597656 C 365.761719 169.597656 350.089844 153.925781 350.089844 134.589844 L 350.089844 117.40625 L 420.105469 117.40625 L 420.105469 134.589844 C 420.105469 153.925781 404.429688 169.597656 385.097656 169.597656 Z M 385.097656 169.597656 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941176%,38.823529%,32.941176%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 315.078125 169.597656 C 295.742188 169.597656 280.070312 153.925781 280.070312 134.589844 L 280.070312 117.40625 L 350.089844 117.40625 L 350.089844 134.589844 C 350.089844 153.925781 334.414062 169.597656 315.078125 169.597656 Z M 315.078125 169.597656 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,24.313725%,22.745098%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 245.0625 169.597656 C 225.726562 169.597656 210.054688 153.925781 210.054688 134.589844 L 210.054688 117.40625 L 280.070312 117.40625 L 280.070312 134.589844 C 280.070312 153.925781 264.394531 169.597656 245.0625 169.597656 Z M 245.0625 169.597656 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941176%,38.823529%,32.941176%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 175.042969 169.597656 C 155.710938 169.597656 140.035156 153.925781 140.035156 134.589844 L 140.035156 117.40625 L 210.054688 117.40625 L 210.054688 134.589844 C 210.054688 153.925781 194.378906 169.597656 175.042969 169.597656 Z M 175.042969 169.597656 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,24.313725%,22.745098%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105.027344 169.597656 C 85.691406 169.597656 70.015625 153.925781 70.015625 134.589844 L 70.015625 117.40625 L 140.035156 117.40625 L 140.035156 134.589844 C 140.035156 153.925781 124.359375 169.597656 105.027344 169.597656 Z M 105.027344 169.597656 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941176%,38.823529%,32.941176%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35.007812 169.597656 C 15.675781 169.597656 0 153.925781 0 134.589844 L 0 117.40625 L 70.019531 117.40625 L 70.019531 134.589844 C 70.019531 153.925781 54.34375 169.597656 35.007812 169.597656 Z M 35.007812 169.597656 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,24.313725%,22.745098%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 490.121094 117.40625 L 420.105469 117.40625 L 392.046875 37.628906 L 432.777344 37.628906 C 443.839844 37.628906 453.9375 43.914062 458.820312 53.835938 Z M 490.121094 117.40625 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333333%,33.72549%,27.45098%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.105469 117.40625 L 350.089844 117.40625 L 333.253906 37.628906 L 392.050781 37.628906 Z M 420.105469 117.40625 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,44.313725%,36.078431%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 350.089844 117.40625 L 280.070312 117.40625 L 274.460938 37.628906 L 333.253906 37.628906 Z M 350.089844 117.40625 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333333%,33.72549%,27.45098%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 280.070312 117.40625 L 210.054688 117.40625 L 215.664062 37.628906 L 274.460938 37.628906 Z M 280.070312 117.40625 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,44.313725%,36.078431%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 210.054688 117.40625 L 140.035156 117.40625 L 156.867188 37.628906 L 215.664062 37.628906 Z M 210.054688 117.40625 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333333%,33.72549%,27.45098%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 140.035156 117.40625 L 70.019531 117.40625 L 98.074219 37.628906 L 156.867188 37.628906 Z M 140.035156 117.40625 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,44.313725%,36.078431%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 70.019531 117.40625 L 0 117.40625 L 31.300781 53.835938 C 36.183594 43.914062 46.28125 37.628906 57.34375 37.628906 L 98.074219 37.628906 Z M 70.019531 117.40625 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333333%,33.72549%,27.45098%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 421.027344 357.234375 L 217.496094 357.234375 C 213.386719 357.234375 210.054688 353.902344 210.054688 349.789062 L 210.054688 230.355469 C 210.054688 226.246094 213.386719 222.910156 217.496094 222.910156 L 421.027344 222.910156 C 425.140625 222.910156 428.472656 226.246094 428.472656 230.355469 L 428.472656 349.789062 C 428.472656 353.902344 425.140625 357.234375 421.027344 357.234375 Z M 421.027344 357.234375 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(23.529412%,33.72549%,40%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 421.027344 222.910156 L 374.828125 222.910156 L 374.828125 357.234375 L 421.027344 357.234375 C 425.140625 357.234375 428.472656 353.902344 428.472656 349.789062 L 428.472656 230.355469 C 428.472656 226.246094 425.140625 222.910156 421.027344 222.910156 Z M 421.027344 222.910156 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.803922%,26.666667%,31.764706%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 234.886719 330.761719 L 234.886719 249.382812 C 234.886719 248.476562 235.621094 247.742188 236.527344 247.742188 L 402.003906 247.742188 C 402.90625 247.742188 403.644531 248.476562 403.644531 249.382812 L 403.644531 330.761719 C 403.644531 331.667969 402.90625 332.402344 402.003906 332.402344 L 236.523438 332.402344 C 235.617188 332.402344 234.886719 331.671875 234.886719 330.761719 Z M 234.886719 330.761719 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(52.941176%,85.882353%,99.215686%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 402.003906 247.742188 L 350 247.742188 L 350 332.402344 L 402.003906 332.402344 C 402.90625 332.402344 403.644531 331.667969 403.644531 330.761719 L 403.644531 249.382812 C 403.644531 248.476562 402.90625 247.742188 402.003906 247.742188 Z M 402.003906 247.742188 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.901961%,76.078431%,91.372549%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 178.644531 444.898438 L 61.648438 444.898438 L 61.648438 230.355469 C 61.648438 226.246094 64.980469 222.910156 69.09375 222.910156 L 171.199219 222.910156 C 175.3125 222.910156 178.644531 226.246094 178.644531 230.355469 Z M 178.644531 444.898438 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(23.529412%,33.72549%,40%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 171.199219 222.910156 L 125 222.910156 L 125 444.898438 L 178.644531 444.898438 L 178.644531 230.355469 C 178.644531 226.246094 175.3125 222.910156 171.199219 222.910156 Z M 171.199219 222.910156 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.803922%,26.666667%,31.764706%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 152.78125 353.707031 C 148.511719 353.707031 145.054688 350.25 145.054688 345.980469 L 145.054688 320.460938 C 145.054688 316.195312 148.511719 312.734375 152.78125 312.734375 C 157.046875 312.734375 160.507812 316.195312 160.507812 320.460938 L 160.507812 345.980469 C 160.507812 350.25 157.046875 353.707031 152.78125 353.707031 Z M 152.78125 353.707031 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(85.882353%,85.098039%,81.960784%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 512 393.4375 C 512 438.171875 475.734375 474.4375 431 474.4375 C 386.261719 474.4375 349.996094 438.171875 349.996094 393.4375 C 349.996094 348.703125 386.261719 312.4375 431 312.4375 C 475.734375 312.4375 512 348.703125 512 393.4375 Z M 512 393.4375 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.823529%,91.764706%,40.784314%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 431 312.4375 C 421.59375 312.4375 412.574219 314.054688 404.175781 317.003906 C 435.722656 328.074219 458.351562 358.105469 458.351562 393.4375 C 458.351562 428.765625 435.722656 458.796875 404.175781 469.867188 C 412.574219 472.816406 421.59375 474.4375 431 474.4375 C 475.734375 474.4375 512 438.171875 512 393.433594 C 512 348.699219 475.734375 312.4375 431 312.4375 Z M 431 312.4375 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,81.568627%,40%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 461.171875 352.855469 L 406.472656 376.394531 L 388.386719 376.394531 C 385.453125 376.394531 383.078125 378.769531 383.078125 381.703125 L 383.078125 405.171875 C 383.078125 408.105469 385.453125 410.480469 388.386719 410.480469 L 406.472656 410.480469 L 461.171875 434.019531 C 463.367188 434.964844 465.816406 433.355469 465.816406 430.964844 L 465.816406 355.910156 C 465.816406 353.519531 463.367188 351.910156 461.171875 352.855469 Z M 461.171875 352.855469 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,94.901961%,94.901961%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 406.472656 410.480469 L 388.386719 410.480469 C 385.453125 410.480469 383.078125 408.105469 383.078125 405.171875 L 383.078125 381.699219 C 383.078125 378.769531 385.453125 376.394531 388.386719 376.394531 L 406.472656 376.394531 Z M 406.472656 410.480469 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,29.019608%,36.470588%)",
      fillOpacity: 1
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.803ccca6.svg";
export { ForwardRef as ReactComponent };